import { useTranslation } from 'react-i18next';
import { getEquipmentTranslation } from '../utils/equipmentTranslation';

const UserReservationCard = ({
  status,
  startDate,
  endDate,
  equipmentName,
  setCancelModal,
  reservation,
  setSelectedReservation,
  setEditModal,
  setShowEditReservationModal,
  equipment,
}) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  // Use translated name if equipment object is available, otherwise use equipmentName prop
  const displayName = equipment
    ? getEquipmentTranslation(equipment, 'name', currentLang)
    : equipmentName;
  const options = {
    day: 'numeric',
    year: 'numeric',
    month: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };

  const STATUS_COLORS = {
    pending: 'bg-yellow-100 text-yellow-800',
    approved: 'bg-green-100 text-green-800',
    'in-use': 'bg-orange-100 text-orange-800',
    canceled: 'bg-red-100 text-red-800',
    filled: 'bg-blue-100 text-blue-800',
    returned: 'bg-purple-100 text-purple-800',
  };

  const statusDisplay = {
    filled: 'To Review',
    'in-use': 'In Use',
    pending: 'Pending',
    approved: 'Approved',
    canceled: 'Canceled',
    returned: 'Returned',
  };

  return (
    <div className="max-w-md w-full bg-white shadow-md rounded-lg overflow-hidden mb-4">
      <div className="p-4 relative">
        <div className="flex justify-between items-start">
          <span
            className={`inline-block px-3 py-1 text-sm font-semibold rounded-full ${STATUS_COLORS[status] || 'bg-gray-200 text-gray-800'}`}
          >
            {statusDisplay[status] || status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
        </div>

        <h2 className="mt-2 text-xl font-bold text-gray-800">{displayName}</h2>

        <div className="mt-4">
          <div className="flex justify-between text-gray-700">
            <span>Start Date:</span>
            <span>{new Date(startDate).toLocaleString('en-US', options)}</span>
          </div>
          <div className="flex justify-between text-gray-700">
            <span>End Date:</span>
            <span>{new Date(endDate).toLocaleString('en-US', options)}</span>
          </div>
        </div>

        <div className="mt-4 flex space-x-2">
          {/* Edit button - only show for pending and approved reservations */}
          {(status === 'pending' || status === 'approved') && (
            <button
              onClick={() => {
                setEditModal(reservation);
                setShowEditReservationModal(true);
              }}
              className="flex-1 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none"
            >
              Edit
            </button>
          )}

          {/* Cancel button - only show for pending and approved reservations */}
          {(status === 'pending' || status === 'approved') && (
            <button
              onClick={() => {
                setCancelModal(true);
                setSelectedReservation(reservation);
              }}
              className="flex-1 px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600 focus:outline-none"
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export { UserReservationCard };
